import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Interfaces
import { ICourse, IInstituteList, IDepartmentList } from 'store/StateInterfaces';

// Assets
import '../Assets/PublicCourses.sass';
import '../Assets/FilterForm.sass';

// Components
import Course from '../Components/Course';
import Navbar from 'Screens/Layout/Common/Components/Navbar';
import FilterForm from './FilterForm';
import Pagination from '../Components/Pagination';

// Actions
import * as actions from '../Actions/Actions';

interface IProps {
    coursesMap: Map<number, ICourse>;
    instituteList: Map<number, IInstituteList>;
    departmentList: Map<number, IDepartmentList>;
    paginationInfo: any;
    actions: any;
    currentPage: any;
    pageLimit: any;
    totalCount: any;
};

interface IState {
    coursesMap: Map<number, ICourse>;
    searchParam: string;
    courseDepartment: string;
    courseInstitute: string;
    currentPage: number;
    pageLimit: number;
    paginationInfo: any;
}

class PublicCoursesPage extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            coursesMap: this.props.coursesMap,
            searchParam: '',
            courseDepartment: '',
            courseInstitute: '',
            currentPage: 1,
            pageLimit: 16,
            paginationInfo: this.props.paginationInfo,
            // totalPages: 0,
        }
    }


    public componentDidMount() {
        if (this.props.coursesMap.size === 0) {
            this.props.actions.loadCoursesListRequest();
        }
        this.setState({
            ...this.state,
            coursesMap: this.props.coursesMap,
            // paginationInfo: this.props.paginationInfo,
            // totalPages: this.props.paginationInfo.count/this.state.pageLimit
        });
        this.props.actions.getAllInstitute();
        this.props.actions.getAllDepartment();
    }
    setCurrentPage = (pageNumber) => {
        this.setState({ currentPage: pageNumber })
    }

    filterByChangeState(name, value): any {
        this.setState({
            ...this.state,
            [name]: value
        }, function () {
            this.reLoadCourses(this.state);
        });
    }

    clearAllState(): any {
        this.setState({
            ...this.state,
            searchParam: '',
            courseDepartment: '',
            courseInstitute: ''
        }, function () {
            this.reLoadCourses(this.state)
        });

    }

    reLoadCourses = (state = null, pageNumber = '', pageLimit = null) => {
        if (!state) {
            state = this.state
        }
        if (!pageLimit) {
            pageLimit = this.state.pageLimit
        }
        if (pageNumber == '') {
            pageNumber = '1';
            this.setCurrentPage(1)
        }
        let offset = pageLimit * (parseInt(pageNumber) - 1)
        // if(pageNumber=='-1' && this.state.currentPage >0){
        //     pageNumber= ''+ (this.state.currentPage -1);
        // }
        // if(pageNumber=='+1' && this.state.currentPage < Math.ceil(this.state.totalCount / this.state.pageLimit) ){
        //     pageNumber= ''+ (this.state.currentPage +1);
        // }
        this.props.actions.loadCoursesListRequest(undefined, state, pageLimit, offset);
    }
    public render() {
        let courses;
        let courseCount = 0;
        let pagination = null;
        let indexStart = 0;
        let indexEnd = 0;
        if (this.props.coursesMap.size !== 0) {
            courses = [];
            this.props.coursesMap.forEach((course) => {
                // if(course.title.toLowerCase().indexOf(this.state.courseName.toLowerCase()) >= 0
                // && course.institute && course.institute.name.toLowerCase().indexOf(this.state.courseInstitute.toLowerCase()) >= 0
                // && course.department && course.department.name.toLowerCase().indexOf(this.state.courseDepartment.toLowerCase()) >= 0
                // ) {
                if (course.course_info.is_published) {
                    courses.push(<Course course={course} key={course.id} />);
                }
                // courseCount++;
                // }
            });
        }
        if (courses && this.props.paginationInfo != null) {
            pagination = <Pagination
                currentPage={this.state.currentPage}
                setCurrentPage={this.setCurrentPage}
                pageLimit={this.state.pageLimit}
                reLoadCourses={this.reLoadCourses}
                props={this.props}
            />
            courseCount = this.props.paginationInfo.totalCourses
            indexStart = (this.state.currentPage - 1) * this.state.pageLimit + 1;
            let end = (indexStart + this.state.pageLimit - 1)
            indexEnd = (end < courseCount) ? end : courseCount;
        }

        if (!courses) {
            if (this.state.searchParam != '' ||
                this.state.courseDepartment != '' ||
                this.state.courseInstitute != '') {
                courses = <div className='alert alert-danger alert-dismissable bt-alert'>No results match your search</div>;

            } else {
                courses = <div className='alert alert-danger alert-dismissable bt-alert'>No courses offered yet</div>;
            }
        }


        return <React.Fragment>
            <Navbar navbarClass='navbar-light' />
            <div className="row public-courses-container">
                <div className="col-md-3 filterForm-container ">
                    <FilterForm
                        clearAllState={this.clearAllState.bind(this)}
                        filterByChangeState={this.filterByChangeState.bind(this)}
                        filterState={this.state}
                        courseCount={courseCount}
                        instituteList={this.props.instituteList}
                        departmentList={this.props.departmentList}
                        reLoadCourses={this.reLoadCourses}
                        // 
                        actions={this.props.actions}
                    // 
                    />
                </div>
                <div className='col-md-8 row public-courses-list'>
                    {(courseCount > 0) ? (
                        <div id="courseCountLabel" className="col-md-12 infoLabel">Showing
                            <span id="courseCount"> {indexStart} - {indexEnd}</span> out of <span id="courseCount"> {courseCount}</span> results
                        </div>
                    ) : ""}
                    {/* {pagination} */}
                    <div className="col-md-12 courseCard-container">
                        {courses}
                    </div>


                    <div className="bt-pafination col-md-12">
                        {pagination}
                    </div>

                </div>

            </div>

        </React.Fragment>;
    }
};

interface IReduxState {
    publicCoursesMap: Map<number, ICourse>;
    instituteList: Map<number, IInstituteList>,
    departmentList: Map<number, IDepartmentList>,
    paginationInfo: any
};

const mapStateToProps = (state: IReduxState) => ({

    coursesMap: state.publicCoursesMap,
    instituteList: state.instituteList,
    departmentList: state.departmentList,
    paginationInfo: state.paginationInfo,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicCoursesPage);
